import { useCallback, useContext, useEffect, useState } from 'react';
import PickersContext from 'ContentComponents/context/PickersContext';
import { DrawerTypes, PickerTypes } from 'file-manager-components/constants';
// @ts-expect-error not typed
import EditorActionsAndEventsContext from 'ContentEditorUI/context/EditorActionsAndEventsContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FilePickerProxyContainer() {
  // @ts-expect-error context isn't typed yet
  const {
    bus
  } = useContext(EditorActionsAndEventsContext);
  const [isOpen, setIsOpen] = useState(false);
  const {
    FilePicker
  } = useContext(PickersContext);
  useEffect(() => {
    const openFilePicker = () => {
      setIsOpen(true);
    };
    bus.on('post:inpageOpenFilePicker', openFilePicker);
    return () => {
      bus.off('post:inpageOpenFilePicker', openFilePicker);
    };
  }, [bus]);
  const onFileManagerClose = useCallback(() => {
    setIsOpen(false);
    bus.postMessage({
      action: 'inpageFilePickerClosed'
    });
  }, [bus]);
  const onSelectImage = useCallback(imageObj => {
    bus.postMessage({
      action: 'filePickerImageChosen',
      data: {
        url: imageObj.default_hosting_url
      }
    });
    onFileManagerClose();
  }, [bus, onFileManagerClose]);
  if (!isOpen) {
    return null;
  }
  if (!FilePicker) {
    throw new Error('FilePickerProxyContainer requires FilePicker to be provided in PickersContext');
  }
  return /*#__PURE__*/_jsx(FilePicker, {
    pickerType: PickerTypes.SIDE_MODAL,
    onClose: onFileManagerClose,
    onSelect: onSelectImage,
    type: DrawerTypes.IMAGE,
    renderContext: "FilePickerProxyContainer"
  });
}